import React from 'react'
import { useLottie } from "lottie-react";
import animationData from './PasswordLottie.json';

export default function Password() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
      const { View } = useLottie(defaultOptions);
      return (
        <div style={{ width: "35px", height: "35px" }} >
          {View}
        </div>
      );
  }
